export default __webpack_public_path__ + "assets/audios/c6857916c6d235ae7b1d274bad074908.mp3";